import { useState } from "react";
import { Button, Col, Container, Form, Image, Modal, Row } from "react-bootstrap"

const HireDevelopers = () => {
    const [show, seShow] = useState(false);

    const handleShow = () => {
        seShow(true)
    }

    const handleClose = () => {
        seShow(false)
    }

    return (
        <Container className="hire-dedicated-developer margin-bottom-70 margin-top-70">
            <Row>
                <Col>
                    <h2 className="section-title">
                        Hire <span>Dedicated Developers</span>
                    </h2>
                    <p>
                        Looking to expand your development team without the hassle of hiring in-house? We provide <b>highly skilled and dedicated developers</b> who work exclusively on your projects, ensuring <b>top-notch quality</b>, faster development, and cost-effective solutions.
                    </p>
                    <p>
                        With a team of <b>experienced developers across various technologies</b>, we help businesses scale efficiently by offering flexible engagement models, seamless collaboration, and transparent project management. Whether you need <b>frontend, backend, full-stack, or CMS experts</b>, our developers are ready to integrate into your team and bring your vision to life.
                    </p>
                    <p>
                        Let us help you build your dream team with experienced, reliable, and highly productive developers who will ensure your project's success.
                    </p>
                    {/* <Button className="default-btn-style border-0" onClick={handleShow}>
                        Hire Now
                        <svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.333984 13.0853C0.333984 12.3847 0.854596 11.8057 1.53007 11.7141L1.71785 11.7015H29.3952C30.1595 11.7015 30.7791 12.3211 30.7791 13.0853C30.7791 13.786 30.2584 14.365 29.5831 14.4567L29.3952 14.4692H1.71785C0.95357 14.4692 0.333984 13.8496 0.333984 13.0853Z" fill="white"></path>
                            <path d="M17.257 2.95003C16.7154 2.41076 16.7136 1.53455 17.2528 0.992943C17.743 0.500582 18.5117 0.454268 19.0544 0.855073L19.2099 0.988736L30.3731 12.1039C30.8669 12.5956 30.9119 13.3671 30.5078 13.9098L30.3731 14.0651L19.2099 25.1822C18.6684 25.7215 17.7923 25.7197 17.2529 25.1781C16.7627 24.6859 16.7195 23.917 17.1227 23.376L17.257 23.2212L27.4349 13.0841L17.257 2.95003Z" fill="white"></path>
                        </svg>
                    </Button> */}

                    <Modal show={show} onHide={handleClose} className="get-in-touch" size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Get In Touch</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Row>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Full Name</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Your Full Name" />
                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Your Email Address" />
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Country</Form.Label>
                                        <Form.Select defaultValue="Select your country" className="form-control"> 
                                            <option>Select your country</option>
                                            <option>...</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>Phone Number</Form.Label>
                                        <Form.Control type="text" placeholder="Enter Your Phone Number" />
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group as={Col} md="12" className="mb-3">
                                        <Form.Label>Select Your Service</Form.Label>
                                        <Form.Select defaultValue="Select your country" className="form-control"> 
                                            <option>Please Select from the dropdown</option>
                                            <option>Software Development</option>
                                            <option>Dedicated Software Development</option>
                                            <option>None of the Above</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group as={Col} className="mb-3">
                                        <Form.Label>How can we help?</Form.Label>
                                        <Form.Control type="text" as="textarea" placeholder="" />
                                    </Form.Group>
                                </Row>
                                <Button className="btn btn-primary default-btn-style border-0" type="submit">
                                    Send Query
                                </Button>
                            </Form>
                        </Modal.Body>
                    </Modal>
                </Col>
                <Col>
                    <Image src="/images/hire-dedicaed-developer.webp" alt="Hire Developers" fluid />
                </Col>
            </Row>
        </Container>
    );
}

export default HireDevelopers;